import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const HistoryRow = styled.div`
  padding: 0.875rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};
`
